<template>
  <CModal
    :show.sync="refundProcess"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Modal title 2"
    size="lg"
    class="doctor-list-modal small-table-padding modal-width"
  >
    <div>
      <div v-if="selectedData.ticket_status === 'pending'">
        {{ selectedData.greivance_description }}
      </div>
      <div
        v-if="
          selectedData.ticket_status === 'pending' &&
            selectedData.greivance_files.length
        "
      >
        <div v-if="selectedData.greivance_files[0].type_of_document === 'pdf'">
          <div class="my-2" v-for="(attachment, index) in selectedData.greivance_files"
            :key="index">
            <img src="/img/avatars/file-pdf.png" alt="PDF file" class="w-2" />
            <span class="mx-2">{{ attachment.link_name }}</span><a @click="showPdf(attachment)">View</a>
          </div>
        </div>
        <div v-else>
          <div
            class="my-2"
            v-for="(attachment, index) in selectedData.greivance_files"
            :key="index"
          >
            <image-view
              :src="attachment.document_url"
              alt="PDF file"
              class="w-2"
            ></image-view>
            <!-- <img src="/img/avatars/014-gallery.png" alt="PDF file" class="w-2" /> -->
            <span class="mx-2">{{ attachment.link_name }}</span
            ><a @click="showImage(attachment)">View</a>
          </div>
        </div>
      </div>
      <div>
        <div
          class="mt-4"
          v-if="
            selectedData.ticket_status === 'refunded' ||
              selectedData.ticket_status === 'rejected'
          "
        >
          <p class="mb-0">
            <b
              >{{
                selectedData.ticket_status === "refunded"
                  ? "Refunded"
                  : "Rejected"
              }}
              Reason</b
            >
          </p>
          <p>
            {{
              selectedData.ticket_status === "refunded"
                ? selectedData.admin_accept_reason
                : selectedData.admin_reject_reason
            }}
          </p>
        </div>
        <div v-if="selectedData.ticket_status === 'pending'">
          <div class="mt-4">
            <CTextarea
              name="testname"
              label="Reason"
              v-model="reason"
              placeholder="Give Reason"
              rows="5"
              v-validate="'required'"
            />
            <span class="text-danger">{{ errors.first("testname") }}</span>
          </div>
        </div>
      </div>
    </div>
    <template #header>
      <h6 class="modal-title">
        {{
          selectedData.ticket_status === "pending"
            ? "Resolve"
            : selectedData.ticket_status === "refunded"
            ? "Grievance Accept Reason"
            : "Grievance Reject Reason"
        }}
      </h6>

      <CButtonClose @click="$emit('close')" />
    </template>
    <template #footer v-if="selectedData.ticket_status === 'pending'">
      <div>
        <CButton
          variant="outline"
          color="danger"
          class="mr-2"
          @click="rejectRefund()"
          >Reject refund</CButton
        >
        <CButton color="success" @click="approveRefund()"
          >Approve refund</CButton
        >
        <!-- <CButton color="success">Submit</CButton> -->
      </div>
    </template>
    <light-box-new
      :images="lightboxImages"
      ref="lightbox"
      :show-light-box="false"
      :show-caption="true"
      :scrolltype="true"
      :showButtons="true"
    ></light-box-new>
    <v-dialog
      v-if="pdfModal"
      v-model="pdfModal"
      width="900px"
      content-class="v-dialog-lg "
      persistent 
      scrollable
    >
      <v-card class="min-height">
        <nav class="border-bottom theme--dark p-2 pl-1" data-booted="true">
          <div class="v-toolbar__content">
            <div class="flex-column">
              <div class="v-toolbar__title" style="margin-bottom: -5px">
                PDF
              </div>
            </div>
            <div class="spacer"></div>
            <button
              type="button"
              class="v-btn v-btn--icon theme--dark"
              @click="pdfModal = false"
            >
              <div class="v-btn__content cursor">
                <!-- <v-icon dark right>cancel</v-icon> -->
                <img src="/img/avatars/remove.png"  style="width:20px;"/>
              </div>
            </button>
          </div>
        </nav>
        <v-card-text class="scrolling">
          <pdf-component
            :src="pdfLink"
            :styles="'width: 100%;height:800px'"
          ></pdf-component>
        </v-card-text>
      </v-card>
    </v-dialog>
  </CModal>
</template>
<script>
const Pdf = () => import("@/components/pdf.vue");
const LightBoxNew = () => import("@/components/lightBoxNew.vue");
const Image = () => import("@/components/image.vue");
import config from "@/config.js";
export default {
  $_veeValidate: {
    validator: "new",
  },
  props: ["refundProcess", "selectedData"],
  data() {
    return {
      reason: "",
      lightboxImages: [],
      pdfLink: null,
      pdfModal: false,
    };
  },
  components: {
    "image-view": Image,
    "light-box-new": LightBoxNew,
    "pdf-component": Pdf,
  },
  methods: {
    showImage(report) {
      this.lightboxImages = [
        {
          src: report.document_url,
          thumb: report.document_url,
          caption: report.link_name,
        },
      ];
      this.$refs.lightbox.showImage(0);
    },
    showPdf(pdf) {
      this.pdfLink = pdf.document_url;
      this.pdfModal = true;
    },
    approveRefund() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$swal({
            text:
              "Are you sure you want to process refund, this will refund the amount back to the patients wallet",
            showCancelButton: true,
            showConfirmButton: true,
            allowOutsideClick: false,
            // icon: "success",
          }).then((result) => {
            if (result.isConfirmed) {
              let url = `${config.BASE_URL}api/v2/admin/greivances/${this.selectedData._id}/accept`;
              let data = {
                admin_accept_reason: this.reason,
              };
              this.$http.patch(url, data).then((res) => {
                if (res.data.status) {
                  this.$swal({
                    text: "Refund processed to patient successfully",
                    icon: "success",
                    allowOutsideClick: false,
                    showCancelButton: false,
                    confirmButtonText: "Ok",
                  });
                  this.$emit("reloadList");
                }
              });
            }
          });
        }
      });
    },
    rejectRefund() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$swal({
            text: "Are you sure you want to reject patient grievance?",
            showCancelButton: true,
            showConfirmButton: true,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              let url = `${config.BASE_URL}api/v2/admin/greivances/${this.selectedData._id}/reject`;
              let data = {
                admin_reject_reason: this.reason,
              };
              this.$http.patch(url, data).then((res) => {
                if (res.data.status) {
                  this.$swal({
                    text: "Patient grievance rejected",
                    icon: "success",
                    allowOutsideClick: false,
                    showCancelButton: false,
                    confirmButtonText: "Ok",
                  });
                  this.$emit("reloadList");
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>

